

















































import Vue from "vue";
import { Component, Prop, Inject } from "vue-property-decorator";
import { IPasswordResetModel } from "../models";
import { RestClient } from "@elite/restclient";
import { LoginRoute } from "../router";
import IView from "./IView";
import { ModelState } from "@elite/validation";

@Component
export default class PasswordReset extends Vue implements IView {
    @Inject()
    restClient!: RestClient;

    @Inject()
    modelState!: ModelState;

    @Prop({ required: true })
    token!: string;

    @Prop({ required: true })
    userId!: number;

    @Prop({ required: true })
    title!: string;

    isLoading = false;

    model: IPasswordResetModel = {
        token: "",
        id: 0,
        newPassword: "",
        confirmPassword: ""
    };

    mounted() {
        // Copy initial model to model for us to use
        this.model.token = this.token;
        this.model.id = this.userId;
    }

    async submit(): Promise<void> {
        this.isLoading = true;

        this.modelState.clear(this);

        const response = await this.restClient.postJson(
            "/api/PasswordReset",
            this.model
        );

        this.isLoading = false;

        if (response.status === 404) {
            this.modelState.modelErrors.push("Invalid user");
            return;
        }

        if (this.modelState.hasErrors(response)) {
            this.modelState.addResponseErrors(response, this);
            return;
        }

        // open the login modal and show the password reset message
        this.$router.push({
            name: LoginRoute.name,
            query: { passwordReset: "true" }
        });
    }
}
